import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { OPTIONAL, REQUIRED } from 'utils/asset/completionModes';
import useUniqueId from 'hooks/useUniqueId';
import FormStack from 'components/FormStack';
import OptionalContentModal from 'screens/OptionalContentModal';
import FormField from 'components/FormField';
import Flex from 'components/Flex';
import InlineList from 'components/InlineList';
import Button from 'components/Button';
import RadioButtonOption from 'components/RadioButtonOption';
import Divider from 'components/Divider';
import Panel from 'components/Panel';
import Heading from 'components/Heading';
import Text from 'components/Text';
var InParentPlaylistPanel = function InParentPlaylistPanel(_ref) {
  var onCompletionModeChange = _ref.onCompletionModeChange,
    _ref$completionMode = _ref.completionMode,
    completionMode = _ref$completionMode === void 0 ? REQUIRED : _ref$completionMode,
    parentPlaylistName = _ref.parentPlaylistName,
    wouldCauseCircularReference = _ref.wouldCauseCircularReference;
  var uniqueId = useUniqueId();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOptionalContentModalOpen = _useState2[0],
    setIsOptionalContentModalOpen = _useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement(Panel, {
    "aria-labelledby": uniqueId
  }, /*#__PURE__*/React.createElement(Heading, {
    as: "h2",
    size: "small",
    id: uniqueId
  }, t('panel_in_parent_playlist_title')), /*#__PURE__*/React.createElement(Text, {
    dimmed: true,
    as: "p",
    mt: "xs",
    mb: "s"
  }, parentPlaylistName), /*#__PURE__*/React.createElement(FormStack, {
    spacing: "m"
  }, /*#__PURE__*/React.createElement(FormField, {
    as: "fieldset",
    label: t('form_completion_mode'),
    horizontal: true,
    description: wouldCauseCircularReference ? t('optional_content_hint_circular_reference') : ''
  }, /*#__PURE__*/React.createElement(Flex, {
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(InlineList, {
    spacing: "m",
    as: "div",
    itemAs: "div"
  }, /*#__PURE__*/React.createElement(RadioButtonOption, {
    key: "completion_".concat(REQUIRED),
    id: REQUIRED,
    label: t('optional_content_required'),
    checked: REQUIRED === completionMode,
    value: REQUIRED,
    onChange: function onChange() {
      return onCompletionModeChange(REQUIRED);
    },
    disabled: wouldCauseCircularReference
  }), /*#__PURE__*/React.createElement(RadioButtonOption, {
    key: "completion_".concat(OPTIONAL),
    id: OPTIONAL,
    label: t('optional_content_optional'),
    checked: OPTIONAL === completionMode,
    value: OPTIONAL,
    onChange: function onChange() {
      return onCompletionModeChange(OPTIONAL);
    }
  })), /*#__PURE__*/React.createElement(Button, {
    icon: "info",
    size: "small",
    variant: "transparent",
    onClick: function onClick() {
      return setIsOptionalContentModalOpen(true);
    }
  }, t('actions_info'))), isOptionalContentModalOpen && /*#__PURE__*/React.createElement(OptionalContentModal, {
    onClose: function onClose() {
      return setIsOptionalContentModalOpen(false);
    }
  })))));
};
export default InParentPlaylistPanel;